import React from 'react';
import SecurityAlerts from './SecurityAlerts';
import { Grid, useMediaQuery } from 'material-ui-core';
import CveBySeverity from './CveBySeverity';
import HighestCVESeverity from './HighestCVESeverity';
import CVEIDByHost from './CVEIDByHost';
import CombinedHostWidget from './CombinedHostWidget';

const NetSpaceSummary = () => {
    const isSmall = useMediaQuery("(max-width:1600px)");
    const isMediumQuery = useMediaQuery("(max-width:2000px)");
    return (
        <div className="summary-parent">
            <div className="netspace-summary-header">Summary</div>
            <div className="summary-grid-container">
                <Grid container spacing={isSmall || isMediumQuery ? 1 : 2} alignItems="stretch">
                    <CombinedHostWidget/>
                    <SecurityAlerts />
                    <CveBySeverity />
                    <HighestCVESeverity/>
                    <CVEIDByHost/>
                </Grid>
            </div>
        </div>
    );
};

export default NetSpaceSummary;